import NewPassword from '../../components/NewPassword';

const SettingsPage = () => {
  return (
    <div style={{ margin: '2rem' }} className="space-y-8">
      <h1 className="text-white text-xl">
        <b>Einstellungen</b>
      </h1>

      <NewPassword />
    </div>
  );
};
export default SettingsPage;
